const state = () => ({  ItemSeleccionado : {},
  contador : 0,
	cargando : false
})

const getters = {
  getContador: ( state ) => {
    return state.contador;
  },
  getCargando: ( state ) => {
    return state.cargando;
  },
} 

const mutations = {
  SALVARCONTADOR : ( state, Contador ) => {
    state.contador = Contador;
  },
  SALVARCARGANDO : ( state, Cargando ) => {
    state.cargando = Cargando;
  },
  SALVARCONTADORMAS : ( state ) => {
    state.contador += 1 ;
  },
  SALVARCONTADORMENOS : ( state ) => {
    state.contador -= 1 ;
  },
  
}

const actions = {
  SetContador( {commit}, Contador ) {
    commit( "SALVARCONTADOR", Contador);
  },
  SetContadorMas( {commit} ) {
    commit( "SALVARCONTADORMAS");
  },
  SetContadorMenos( {commit} ) {
    commit( "SALVARCONTADORMENOS");
  },
  SetCargando( {commit}, Cargando ) {
    commit( "SALVARCARGANDO", Cargando);
  },
  
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}